export const deprecate = (fn, msg) => {
    // 注意由于这里内部需要使用 this，所以不能用箭头函数
    function fnWithDeprecatedMsg(...args) {
        console.warn(msg);
        return fn.call(this, ...args);
    }
    return fnWithDeprecatedMsg;
};
const inferNewFnName = (oldName) => oldName.replace('Block', 'Node').replace('Inline', 'Mark');
export const renameFnWarn = (oldName, newName) => {
    return `exeditor: ${oldName}() is deprecated. Use ${newName || inferNewFnName(oldName)}() instead.`;
};
//# sourceMappingURL=deprecate.js.map